import { render, staticRenderFns } from "./PatientSurgeryInfo.vue?vue&type=template&id=764132f9&scoped=true"
import script from "./PatientSurgeryInfo.vue?vue&type=script&lang=js"
export * from "./PatientSurgeryInfo.vue?vue&type=script&lang=js"
import style0 from "./PatientSurgeryInfo.vue?vue&type=style&index=0&id=764132f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764132f9",
  null
  
)

export default component.exports